// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"9783819b","223":"a71e5913","287":"716a97f4","403":"9a23a1d4","437":"0d9ef206","450":"b188360b"}[chunkId] + ".chunk.js";
};